module.exports = __webpack_public_path__ + "img/charger-installation.e6d310e9.png";